import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import Data from './Data';
import View from './View';
import type { MainContentReaderBlockData } from './index';

interface Props {
  data: MainContentReaderBlockData;
  onChangeBlock: (id: string, data: MainContentReaderBlockData) => void;
  block: string;
  selected: boolean;
  [key: string]: any;
}

const Edit: React.FC<Props> = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <View {...props} />
      <SidebarPortal selected={selected}>
        <Data data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
